<template lang="pug" src="./loggingEditor.pug"> </template>
<style lang="scss" src="./loggingEditor.scss" scoped> </style>

<script>
import { mapState } from 'vuex';

export default {
    data: () => ({
        isChanged: false,
        page: 1,
        pageCount: 0,
        itemsPerPage: 10,
    }),
    computed: {
        ...mapState({
            actionTypes(state) {
                return state.logging.actionTypes.map(it => ({
                    action: this.$vuetify.lang.t(`$vuetify.actionTypes.${it.name}`),
                    enabled: it.enabled,
                    id: it.id,
                    isDisabled: ['change-action-type-status'].includes(it.name)
                }));
            },
        }),
        headers() {
            return ['action', 'enabled'].map(it => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.LoggingEditor.table.${it}`),
                value: it,
                sortable: false,
                align: 'center'
            }));
        },
    },
    created: function() {
        this.$store.dispatch('logging/getActionTypes');
    },
    methods: {
        onActionsSave() {
            this.$store.dispatch('logging/editActions', {
                enabled: this.actionTypes.filter(it => it.enabled).map('id')
            }).then(() => {
                this.isChanged = false;
            });
        },
        onActionChange() {
            this.isChanged = true;
        }
    }
};
</script>
